/* ka-i18n（2026-10 海外対応）：英語などのページだけ #ka-i18n-dictionary の訳を使う。日本語のページでは辞書がないので、元の日本語をそのまま返す。 */
var kaT = (typeof window !== 'undefined' && window.kaT) || (function () {
  var dict;
  function load() { if (dict === undefined) { var el = document.getElementById('ka-i18n-dictionary'); if (!el) return null; try { dict = JSON.parse(el.textContent); } catch (e) { dict = null; } } return dict; }
  var f = function (key, ja) { var d = load(); return d && Object.prototype.hasOwnProperty.call(d, key) ? d[key] : ja; };
  f.on = function () { return !!load(); };
  f.val = function (v) { var d = load(); if (!d) return v; var m = d['kawaii.js.values_html']; if (typeof m === 'string') { try { m = d['kawaii.js.values_html'] = JSON.parse(m); } catch (e) { m = {}; } } return (m && m[v]) || v; };
  // 長い HTML の文は、日本語の部分だけを1つずつ訳に置き換える（言語ファイルの1つの値の長さに上限があるため）
  f.rep = function (s, pairs) { if (!load()) return s; for (var i = 0; i < pairs.length; i++) s = s.split(pairs[i][0]).join(f(pairs[i][1], pairs[i][0])); return s; };
  f.money = function (cents) { var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'; return new Intl.NumberFormat('en-US', { style: 'currency', currency: c }).format(cents / 100); };
  window.kaT = f; return f;
})();
// 購入欄の本体（選択・合計・カートへの追加・作品ガイド）。8作家とミニで共通（2026-09-24 購入欄の整理 段階1、ミニは9/26 段階3から）。
// 以前は作家ごとに ka-{denny,hz,kr,mi,mo,on,ri,rk}-product.js の8コピーで、中身は作家記号だけが違っていた。
// 作家記号 A は購入欄の <section data-ka-artist="…">（snippets/ka-{作家}-purchase.liquid）から読む。
// 属性名・クラス名（data-{作家}-…、ka-sunset-{作家}-…）は各作家の snippet・CSS と同じものを使うので、見た目と動きは変わらない。
// ミニ（snippets/ka-mini-purchase.liquid、data-ka-artist="mini"）も9/26からこれを使う。以前の ka-mini-product.js との違いはメッセージ入れ欄がないことだけ。
(() => {
  // 追加後の動き（9/24 ユーザー決定：A＝カート画面へ）。小窓・引き出しにするときはここと afterAdd だけを変える。
  // カートへの追加そのものは、今までどおり /cart/add.js に直接送る（9/26 ユーザー決定）。
  //  テーマの Cart ストア（Cart.add）は、追加のあとカートの読み直しまでを1つの処理にしていて、読み直しだけが失敗しても「失敗」になる。
  //  追加できているのに「追加できませんでした」と出て、押し直すと二重に入るため使わない（Codex 段階3レビュー R1）。
  //  小窓・引き出しにするときは、追加が成功したあとに Cart ストアの refresh で上部の数・引き出しを合わせる（失敗しても再追加はさせない）。
  const AFTER_ADD = 'cart';
  function afterAdd(rootPath) {
    if (AFTER_ADD === 'cart') window.location.assign(rootPath + 'cart');
  }

  // 9/26 段階3：「戻る」で前の画面がそのまま復元されたとき（Safari など）の購入欄の直しを、ここ1か所にまとめた。
  // 以前は ka-product.js・ka-mini-product.js・ka-artwork-purchase-cards.js・ka-mini-purchase-cards.js の4か所（9/23〜24の修正）。
  //  1. 通信中に押せなくした「カートに入れる」を押せる状態に戻す（売り切れ等でテーマが止めている .js-product-buttons.is-disabled は除く）
  //  2. 名入れ・のしの入力の小窓が開いたままなら閉じる（二重に追加されないように。選んだ内容と入力した文字は残す）。ミニの小窓の追加ボタンも戻す
  // カートバー（ka-sticky-cart）・発送目安（ka-business-days）・カート情報の取り直し（cart-components.js）は、それぞれのファイルのまま（9/26 ユーザー決定）。
  // フォームの一覧はページで1つ（このJSがもう一度実行されても同じ一覧に足し、1つだけの pageshow の処理から届くように。Codex 段階3レビュー R2）
  const restoreForms = (window.kaPurchaseRestoreForms ||= new Set());
  const restoreQuantities = (window.kaPurchaseRestoreQuantities ||= new Set()); // 9/28 戻る後に合計金額を合わせる数量欄（ページで1つ）
  if (!window.kaPurchaseRestoreBound) {
    window.kaPurchaseRestoreBound = true;
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      restoreForms.forEach((form) => {
        const addButton = form.querySelector('[name="add"], button[type="submit"]');
        if (addButton?.disabled && !form.querySelector('.js-product-buttons.is-disabled')) addButton.disabled = false;
      });
      document.querySelectorAll('dialog.ka-hz20-entry-dialog[open], dialog.ka-mini-entry-dialog[open]').forEach((dialog) => dialog.close());
      document.querySelectorAll('.ka-mini-entry-dialog .ka-mini-entry-add').forEach((button) => { button.disabled = false; });
      // 3. 9/28 数量欄：iPhone Safari は画面復元のとき数量欄（autocomplete="off"）を初期値1に戻すが、知らせが出ないので合計金額が前の数量のまま残る。
      //    数量欄に change を送って合計金額を今の数量に合わせる（数量は1のまま＝ユーザー決定A）。
      //    ブラウザが戻す時期は決まっていないので、直後に1回送り、その後3秒間は0.1秒ごとに値を見て、変わったときだけ送る（Codex 指摘 P2）。
      //    お客様が数量欄に入力・キー操作・指やマウスで触ったら、その欄の見張りはやめる（打ち直しの途中の空欄を1に直さないため。Codex 第2回 P2。フォーカスだけでは止めない＝第3回 P2）。
      //    対象は合計金額の計算と同じ数量欄（下の quantityInput() で登録したもの。Codex 指摘 P3）。ページから外れた欄は一覧から除く（第2回 P3）
      restoreQuantities.forEach((input) => { if (!input.isConnected) restoreQuantities.delete(input); });
      const quantities = [...restoreQuantities];
      const syncQuantity = (input) => input.dispatchEvent(new Event('change', { bubbles: true }));
      quantities.forEach(syncQuantity);
      const lastValues = new Map(quantities.map((input) => [input, input.value]));
      const touched = new Set();
      const stopListening = new AbortController();
      quantities.forEach((input) => {
        const touch = () => touched.add(input);
        ['input', 'keydown', 'pointerdown'].forEach((type) => input.addEventListener(type, touch, { signal: stopListening.signal }));
        input.closest('quantity-input')?.addEventListener('pointerdown', touch, { signal: stopListening.signal });
      });
      let checks = 0;
      const watch = setInterval(() => {
        quantities.forEach((input) => { if (touched.has(input) || input.value === lastValues.get(input)) return; lastValues.set(input, input.value); syncQuantity(input); });
        if (++checks >= 30 || touched.size === quantities.length) { clearInterval(watch); stopListening.abort(); }
      }, 100);
    });
  }

  const initArtist = (A) => {
    (() => {
    function upgradeThumbnailSources(productSingle) {
          if (!productSingle) return;
          const widths = [120, 240, 360];
          productSingle.querySelectorAll('.media-gallery__thumb-image').forEach((thumbnail) => {
            const existingSources = thumbnail.getAttribute('srcset') || '';
            const largestSource = existingSources.split(',').at(-1)?.trim().split(/\s+/)[0] || thumbnail.src;
            const sourceUrl = new URL(largestSource, document.baseURI);
            const sourceWidth = Number(sourceUrl.searchParams.get('width')) || thumbnail.naturalWidth || 1;
            const sourceHeight = Number(sourceUrl.searchParams.get('height')) || thumbnail.naturalHeight || sourceWidth;
            const aspectRatio = sourceHeight / sourceWidth;
            const upgradedSources = widths.map((width) => {
              const candidateUrl = new URL(sourceUrl);
              candidateUrl.searchParams.set('width', String(width));
              candidateUrl.searchParams.set('height', String(Math.round(width * aspectRatio)));
              return `${candidateUrl.toString()} ${width}w`;
            });
            thumbnail.setAttribute('srcset', upgradedSources.join(', '));
            thumbnail.setAttribute('sizes', '120px');
          });
        }

        function initializePurchaseOptions() {
          const roots = [...document.querySelectorAll(`[data-ka-sunset-${A}-purchase]`)];
          roots.forEach((root) => {
          if (root.dataset.ready === 'true') return;
          root.dataset.ready = 'true';
          const variantsNode = root.querySelector(`[data-${A}-variants-json]`);
          const variants = JSON.parse(variantsNode?.textContent || '[]');

          const section = root.closest('[id^="shopify-section-"]') || document;
          const productRegion = root.closest('.product-single__box, product-single, [data-section-type*="product"], product-info, .product') || section;
          productRegion?.setAttribute?.(`data-${A}-product-region`, '');
          const productSingle = root.closest('product-single') || section.querySelector?.('product-single');
          if (productSingle) productSingle.setAttribute(`data-${A}-product-single`, '');
          upgradeThumbnailSources(productSingle);
          const productSection = productSingle?.closest('.section--product-single');
          if (productSection) productSection.setAttribute(`data-${A}-product-section`, '');
          const form = productRegion.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
          const nativeVariantInput = () => form?.querySelector('[name="id"]');
          const productSectionId = form?.getAttribute('id')?.replace(/^product-form-/, '');
          const messageToggle = root.querySelector(`[data-${A}-message-toggle]`);
          const messageFields = root.querySelector(`[data-${A}-message-fields]`);
          const wrapping = root.querySelector(`[data-${A}-wrapping]`);
          const noshi = root.querySelector(`[data-${A}-noshi]`);
          const noshiFields = root.querySelector(`[data-${A}-noshi-fields]`);
          const noshiContent = root.querySelector(`[data-${A}-noshi-content]`);
          const errorOutput = root.querySelector(`[data-${A}-gift-error]`);
          const sizeOutput = root.querySelector(`[data-${A}-size]`);
          const frameOutput = root.querySelector(`[data-${A}-frame]`);
          const wrappingOutput = root.querySelector(`[data-${A}-wrapping-summary]`);
          const noshiOutput = root.querySelector(`[data-${A}-noshi-summary]`);
          const priceOutput = root.querySelector(`[data-${A}-price]`);
          const pointsOutput = root.querySelector(`[data-${A}-points-value]`);
          const pointsContainer = root.querySelector(`[data-${A}-points]`);
          const pointsRatePercent = Number(pointsContainer?.dataset.poingpongRatePercent || 0);
          const shippingRoot = root.parentElement?.querySelector(`[data-ka-sunset-${A}-shipping]`)
            || document.querySelector(`[data-ka-sunset-${A}-shipping]`);
          const dispatchOutput = shippingRoot?.querySelector(`[data-${A}-dispatch]`);
          const buyBlock = productRegion.querySelector('.product-single__box__block--buy_buttons');
          if (shippingRoot && buyBlock && buyBlock.nextElementSibling !== shippingRoot) {
            buyBlock.after(shippingRoot);
          }
          const approvedFrames = ['オークカラー', 'ホワイト（木目調）', 'ブラウン（木目調）', 'ホワイト(木目調)', 'ブラウン(木目調)', 'パールホワイト'];

          function selectedVariant() {
            return variants.find((variant) => String(variant.id) === String(nativeVariantInput()?.value));
          }

          function displayFrame(value) {
            const normalized = String(value || '').replace(/額$/, '');
            if (normalized === 'オーク' || normalized === 'Oak') return 'オークカラー';
            if (normalized === '白') return 'ホワイト（木目調）';
            if (normalized === 'ブラウン' || normalized === 'Brown') return 'ブラウン（木目調）';
            return normalized;
          }

          function displayNoshi(value) {
            return String(value || '熨斗なし').replace(/熨斗/g, 'のし');
          }

          function nativeFrameRadios() {
            return [...(productRegion.querySelectorAll?.('input[type="radio"][name="額縁"]') || [])];
          }

          function decorateNativeVariantPicker() {
            const frameHeading = nativeFrameRadios()[0]?.closest?.('fieldset')?.querySelector?.('legend');
            if (frameHeading) frameHeading.textContent = kaT('kawaii.js.product_frame_legend_html', '額縁の種類');
            nativeFrameRadios().forEach((radio) => {
              const item = radio.closest?.('.product-form__swatch__item');
              const label = item?.querySelector?.(`label[for="${radio.id}"]`);
              const approved = approvedFrames.includes(displayFrame(radio.value));
              if (item) item.hidden = !approved;
              radio.disabled = !approved;
              if (radio.value === '白') {
                if (item) item.title = kaT.val('ホワイト（木目調）');
                if (label) label.textContent = kaT.val('ホワイト（木目調）');
              }
              if (radio.value === 'オーク') {
                if (item) item.title = kaT.val('オークカラー');
                if (label) label.textContent = kaT.val('オークカラー');
              }
              if (radio.value === 'ブラウン') {
                if (item) item.title = kaT.val('ブラウン（木目調）');
                if (label) label.textContent = kaT.val('ブラウン（木目調）');
              }
            });
          }

          function formatMoney(cents) {
            if (kaT.on()) return kaT.money(cents);
            if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents);
            return new Intl.NumberFormat('ja-JP', {
              style: 'currency',
              currency: 'JPY',
              maximumFractionDigits: 0,
            }).format(Number(cents || 0) / 100);
          }

          function quantityInput() {
            return form?.querySelector('[name="quantity"]') || productRegion.querySelector('[name="quantity"]');
          }

          function selectedQuantity() {
            return Math.max(1, Number(quantityInput()?.value || 1));
          }

          function syncMessageFields() {
            if (!messageToggle) return; // メッセージ入れ欄がない購入欄（ミニ）は発送目安の文字を変えない
            const messageEnabled = Boolean(messageToggle?.checked);
            if (messageFields) messageFields.hidden = !messageEnabled;
            messageFields?.querySelectorAll('input, textarea, select').forEach((control) => {
              control.disabled = !messageEnabled;
            });
            if (dispatchOutput) {
              dispatchOutput.textContent = messageEnabled ? kaT('kawaii.js.product_dispatch_message_html', "注文受付後1〜3営業日で発送（レイアウト確認後1〜2営業日で発送） ※レイアウトへのOKのお返事をいただいてから発送します。ご返信の時期や修正内容によっては、上記の目安より日数がかかる場合があります。") : kaT('kawaii.js.product_dispatch_plain_html', '1〜2営業日で発送');
            }
          }

          function syncNoshiFields() {
            const enabled = Boolean(noshi && noshi.value !== '熨斗なし');
            if (noshiFields) noshiFields.hidden = !enabled;
            if (noshiContent) noshiContent.disabled = !enabled;
          }

          function syncPurchaseSummary() {
            decorateNativeVariantPicker();
            const variant = selectedVariant();
            if (variant) {
              if (sizeOutput) sizeOutput.textContent = kaT.val(variant.option1 || '');
              if (frameOutput) frameOutput.textContent = kaT.val(displayFrame(variant.option2));
            }
            if (wrappingOutput) wrappingOutput.textContent = kaT.val(wrapping?.value || 'ラッピングなし');
            if (noshiOutput) noshiOutput.textContent = displayNoshi(noshi?.value);
            const quantity = selectedQuantity();
            const variantPrice = Number(variant?.price || 0);
            const wrappingFee = Number(wrapping?.selectedOptions?.[0]?.dataset.feePrice || 0);
            const noshiFee = Number(noshi?.selectedOptions?.[0]?.dataset.noshiFeePrice || 0);
            const totalCents = quantity * (variantPrice + wrappingFee + noshiFee);
            if (priceOutput) priceOutput.textContent = formatMoney(totalCents);
            if (pointsOutput && Number.isFinite(pointsRatePercent)) {
              pointsOutput.textContent = Math.floor((totalCents * pointsRatePercent) / 10000);
            }
          }

          function messageProperties() {
            const properties = {};
            if (!messageToggle?.checked || !messageFields) return properties;
            messageFields.querySelectorAll('[name^="properties["]').forEach((control) => {
              const key = control.name.match(/^properties\[(.+)\]$/)?.[1];
              const value = control.value.trim();
              if (key && value) properties[key] = value;
            });
            return properties;
          }

          function collectGiftItems(token) {
            const variantInput = nativeVariantInput();
            if (!form || !variantInput) return [];
            const selectedWrapping = wrapping?.selectedOptions?.[0];
            const selectedNoshi = noshi?.selectedOptions?.[0];
            const wrappingFeeVariantId = selectedWrapping?.dataset.feeVariantId;
            const noshiFeeVariantId = selectedNoshi?.dataset.noshiFeeVariantId;
            const quantity = Math.max(1, Number(quantityInput()?.value || 1));
            const properties = {
              ...messageProperties(),
              'ラッピング': wrapping?.value || 'ラッピングなし',
              'のし': displayNoshi(noshi?.value),
            };
            const purposeSelect = root.querySelector(`[data-${A}-purpose]`);
            if (purposeSelect && purposeSelect.value) properties['ご利用用途'] = purposeSelect.value;

            if (noshi?.value !== '熨斗なし') {
              properties['のしの記載内容'] = noshiContent?.value.trim() || '';
            }
            if (wrappingFeeVariantId || noshiFeeVariantId) {
              properties._dn13_gift_token = token;
              properties._dn13_gift_role = 'main';
            }

            const items = [{ id: Number(variantInput.value), quantity, properties }];
            if (wrappingFeeVariantId) {
              items.push({
                id: Number(wrappingFeeVariantId),
                quantity,
                properties: {
                  _dn13_gift_token: token,
                  _dn13_gift_role: 'fee',
                  _dn13_gift_fee_type: 'wrapping',
                },
              });
            }
            if (noshiFeeVariantId) {
              items.push({
                id: Number(noshiFeeVariantId),
                quantity,
                properties: {
                  _dn13_gift_token: token,
                  _dn13_gift_role: 'fee',
                  _dn13_gift_fee_type: 'art-noshi',
                },
              });
            }
            return items;
          }

          async function submitPurchase(event) {
            if (event.target !== form) return;
            event.preventDefault();
            event.stopImmediatePropagation();

            if (noshi?.value !== '熨斗なし' && !noshiContent?.value.trim()) {
              if (errorOutput) {
                errorOutput.hidden = false;
                errorOutput.textContent = kaT('kawaii.js.product_noshi_required_html', 'のしの記載内容をご入力ください。');
              }
              noshiContent?.focus();
              return;
            }

            if (errorOutput) errorOutput.hidden = true;
            const addButton = form.querySelector('[name="add"], button[type="submit"]');
            if (addButton) addButton.disabled = true;
            const token = window.crypto?.randomUUID?.() || `dn13-${Date.now()}-${Math.random().toString(16).slice(2)}`;
            const items = collectGiftItems(token);
            const rootPath = window.Shopify?.routes?.root || '/';

            try {
              const response = await fetch(rootPath + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items }),
              });
              if (!response.ok) throw new Error('cart add failed');
              afterAdd(rootPath);
            } catch (error) {
              if (addButton) addButton.disabled = false;
              if (errorOutput) {
                errorOutput.hidden = false;
                errorOutput.textContent = kaT('kawaii.js.product_add_failed_html', 'カートに追加できませんでした。時間をおいて、もう一度お試しください。');
              }
            }
          }

          messageToggle?.addEventListener('change', () => {
            syncMessageFields();
            syncPurchaseSummary();
          });
          wrapping?.addEventListener('change', syncPurchaseSummary);
          noshi?.addEventListener('change', () => {
            syncNoshiFields();
            syncPurchaseSummary();
          });
          productRegion.addEventListener('change', () => requestAnimationFrame(syncPurchaseSummary));
          productRegion.addEventListener('click', (event) => {
            if (!event.target.closest?.('.product-single__box__block--quantity_selector')) return;
            requestAnimationFrame(syncPurchaseSummary);
          });
          document.addEventListener('variant:changed', (event) => {
            if (event.detail?.sectionId && productSectionId && event.detail.sectionId !== productSectionId) return;
            syncPurchaseSummary();
          });
          form?.addEventListener('submit', submitPurchase, true);
          if (form) restoreForms.add(form); // 「戻る」の直しは上の1か所（9/26 段階3）
          const quantityControl = quantityInput();
          if (quantityControl) restoreQuantities.add(quantityControl); // 9/28 戻る後の数量と合計金額の同期（上の pageshow）
          quantityControl?.addEventListener('change', syncPurchaseSummary);
          quantityControl?.addEventListener('input', syncPurchaseSummary);
          const initialVariantInput = nativeVariantInput();
          if (initialVariantInput) {
            initialVariantInput.addEventListener('change', syncPurchaseSummary);
            new MutationObserver(syncPurchaseSummary).observe(initialVariantInput, {
              attributes: true,
              attributeFilter: ['value'],
            });
          }

          syncMessageFields();
          syncNoshiFields();
          syncPurchaseSummary();
          });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initializePurchaseOptions, { once: true });
        } else {
          initializePurchaseOptions();
        }
        // テーマエディタで section を読み直したときも購入欄を初期化する（初期化済みは data-ready で飛ばす）
        if (window.kaPurchaseSectionLoadBound?.[A] !== true) {
          window.kaPurchaseSectionLoadBound = { ...(window.kaPurchaseSectionLoadBound || {}), [A]: true };
          document.addEventListener('shopify:section:load', initializePurchaseOptions);
        }
      })();

    (() => {
        const guideSelector = `[data-ka-sunset-${A}-guide]`;
        const guideRoots = (context) => [
          ...(context.matches?.(guideSelector) ? [context] : []),
          ...context.querySelectorAll(guideSelector),
        ];
        const guideCleanups = new WeakMap();
        const relatedOwners = new WeakMap();

        const initDn13Guide = (root) => {
          if (!root || root.dataset.guideReady === 'true') return;
          root.dataset.guideReady = 'true';
          let frameOpener = null;
          let frameScrollPosition = { x: 0, y: 0 };

          (root.querySelectorAll?.(`[data-${A}-frame-open]`) || []).forEach((opener) => {
            const dialogId = opener.getAttribute(`data-${A}-frame-open`);
            const dialog = dialogId ? root.querySelector(`#${dialogId}`) : null;
            if (!dialog) return;
            opener.addEventListener('click', () => {
              frameOpener = opener;
              frameScrollPosition = { x: window.scrollX, y: window.scrollY };
              dialog.showModal();
            });
          });
          (root.querySelectorAll?.(`[data-${A}-frame-dialog]`) || []).forEach((dialog) => {
            dialog.querySelector(`[data-${A}-frame-close]`)?.addEventListener('click', () => dialog.close());
            dialog.addEventListener('click', (event) => {
              if (event.target === dialog) dialog.close();
            });
            dialog.addEventListener('close', () => {
              frameOpener?.focus({ preventScroll: true });
              window.scrollTo({ left: frameScrollPosition.x, top: frameScrollPosition.y, behavior: 'auto' });
              frameOpener = null;
            });
          });

          (root.querySelectorAll?.(`.ka-sunset-${A}-guide__spec-toggle`) || []).forEach((toggle) => {
            const panelId = toggle.getAttribute('aria-controls');
            const panel = panelId ? root.querySelector(`#${panelId}`) : null;
            if (!panel) return;
            toggle.addEventListener('click', () => {
              const expanded = toggle.getAttribute('aria-expanded') === 'true';
              toggle.setAttribute('aria-expanded', String(!expanded));
              panel.hidden = expanded;
              const symbol = toggle.querySelector('[aria-hidden="true"]');
              if (symbol) symbol.textContent = expanded ? kaT('kawaii.js.product_plus_html', '＋') : '−';
            });
          });

          const guideSection = root.closest?.('.shopify-section');
          let relatedSection = null;
          const syncRelatedSection = () => {
            const liveRelatedSection = guideSection?.parentElement?.querySelector?.('.js-section__product-recommendations') || null;
            if (relatedSection && relatedSection !== liveRelatedSection && relatedOwners.get(relatedSection) === root) {
              relatedSection.removeAttribute(`data-${A}-related-products`);
              relatedOwners.delete(relatedSection);
            }
            if (!liveRelatedSection?.matches?.('.shopify-section')) {
              relatedSection = null;
              return;
            }
            relatedSection = liveRelatedSection;
            relatedSection.setAttribute(`data-${A}-related-products`, '');
            relatedOwners.set(relatedSection, root);
            const normalizeRelatedImageUrl = (value) => value?.replace(/([?&])crop=center&?/g, '$1').replace('?&', '?').replace(/&&+/g, '&');
            relatedSection.querySelectorAll?.('.product-card__img').forEach((image) => {
              const source = image.getAttribute('src');
              const sourceSet = image.getAttribute('srcset');
              if (source?.includes('crop=center')) image.setAttribute('src', normalizeRelatedImageUrl(source));
              if (sourceSet?.includes('crop=center')) image.setAttribute('srcset', normalizeRelatedImageUrl(sourceSet));
            });
          };
          syncRelatedSection();
          const relatedObserver = typeof MutationObserver === 'function' && guideSection?.parentElement
            ? new MutationObserver(syncRelatedSection)
            : null;
          relatedObserver?.observe(guideSection.parentElement, { childList: true, subtree: true });


          guideCleanups.set(root, () => {
            relatedObserver?.disconnect();
            if (relatedSection && relatedOwners.get(relatedSection) === root) {
              relatedSection.removeAttribute(`data-${A}-related-products`);
              relatedOwners.delete(relatedSection);
            }
            guideCleanups.delete(root);
          });
        };

        guideRoots(document).forEach(initDn13Guide);
        if (window.kaSunsetDn13GuideSectionLoadBound?.[A] !== true) {
          window.kaSunsetDn13GuideSectionLoadBound = { ...(window.kaSunsetDn13GuideSectionLoadBound === true ? {} : window.kaSunsetDn13GuideSectionLoadBound), [A]: true };
          document.addEventListener('shopify:section:load', (event) => {
            guideRoots(event.target).forEach(initDn13Guide);
          });
          document.addEventListener('shopify:section:unload', (event) => {
            guideRoots(event.target).forEach((root) => guideCleanups.get(root)?.());
          });
        }
      })();
  };
  const artists = [...new Set([...document.querySelectorAll('[data-ka-artist]')].map((el) => el.dataset.kaArtist).filter((a) => /^[a-z]+$/.test(a || '')))];
  artists.forEach(initArtist);
})();
